export default function removeStyleTagsFromHtml(htmlString) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  const styles = doc.getElementsByTagName('style');
  for (let i = 0; i < styles.length; i += 1) {
    styles[i].remove();
  }
  return doc.documentElement.innerHTML;
}
